import { Pipe, PipeTransform } from '@angular/core';
import { IDisplaySlide, isVideoHotspot } from '@pcp/core/interfaces';
import { VideoPlayerInputProps } from '@pcp/streaming';

@Pipe({
    name: 'asVideoElementInput',
    pure: true
})
export class AsVideoElementInputPipe implements PipeTransform {
    transform(slide: IDisplaySlide): VideoPlayerInputProps {
        if (!slide.vimeoVideoId) {
            throw new Error(
                'Slide is not a valid video slide: missing vimeo video id'
            );
        }

        return {
            slideId: slide.id,
            vimeoId: slide.vimeoVideoId,
            range: slide.videoRange,
            pausePoints: slide.videoPausePoints,
            hotspots: (slide.hotspots ?? []).filter(isVideoHotspot),
            autoClose: slide.autoClose === true,
        };
    }
}
